/**
 * Pricing Configuration
 *
 * IMPORTANT: On April 1st, 2027, change IS_PROMO_ACTIVE to false (launch special runs through March 31st, 2027)
 * This will automatically update all pricing throughout the application
 */

export const PRICING_CONFIG = {
  // 🚨 SET TO FALSE ON APRIL 1ST, 2026
  IS_PROMO_ACTIVE: true,

  MONTHLY_CALENDAR: {
    // Promotional pricing (until March 31st, 2026)
    promo: {
      price: '4.99',
      amount_cents: 499,
      description: 'Launch Special - Available until March 31st',
      features: [
        '🎉 Launch Special: $4.99 for 30 days (offer ends March 31st)',
        '🔒 Guaranteed: Lock in $4.99/month for future renewals',
        '30 days of calendar access from your purchase date',
        'Example: Purchase Jan 15 → Access until Feb 14',
        'Navigate through all weeks within your 30-day period',
        'Detailed aspect interpretations (as seen on your weekly calendar view)',
        'House positions for all transits (as seen on your weekly calendar view)',
        'Exact timing for all aspects (as seen on your weekly calendar view)',
        'Personalized to your natal chart',
        'Mobile and desktop access'
      ],
      badgeText: 'LAUNCH SPECIAL',
      subText: 'Launch Special - Lock in this price forever!',
      checkoutTotal: '$4.99/mo'
    },

    // Regular pricing (starting April 1st, 2026)
    regular: {
      price: '7.99',
      amount_cents: 799,
      description: '30 days of calendar access from purchase date',
      features: [
        '30 days of calendar access from your purchase date',
        'Example: Purchase Jan 15 → Access until Feb 14',
        'Navigate through all weeks within your 30-day period',
        'Detailed aspect interpretations (as seen on your weekly calendar view)',
        'House positions for all transits (as seen on your weekly calendar view)',
        'Exact timing for all aspects (as seen on your weekly calendar view)',
        'Personalized to your natal chart',
        'Mobile and desktop access',
        'Cancel anytime'
      ],
      badgeText: 'MOST POPULAR',
      subText: null,
      checkoutTotal: '$7.99/mo'
    }
  },

  ANNUAL_CALENDAR: {
    // Promotional pricing (until March 31st, 2026)
    promo: {
      price: '49.99',
      amount_cents: 4999,
      description: 'Launch Special - Available until March 31st',
      features: [
        '🎉 Launch Special: $49.99 for full year access (offer ends March 31st)',
        '🔒 Guaranteed: Lock in $49.99/year for future renewals',
        '365 days of calendar access starting from your purchase date',
        'Example: Purchase Mar 5, 2026 → Access until Mar 5, 2027',
        'Navigate through all months of your full year',
        'Detailed aspect interpretations (as seen on your weekly calendar view)',
        'House positions for all transits (as seen on your weekly calendar view)',
        'Exact timing for all aspects (as seen on your weekly calendar view)',
        'Personalized to your natal chart',
        'Priority support',
        'Mobile and desktop access'
      ],
      badgeText: 'LAUNCH SPECIAL',
      subText: 'Launch Special - Lock in this price forever!',
      checkoutTotal: '$49.99/year'
    },

    // Regular pricing (starting April 1st, 2026)
    regular: {
      price: '99.99',
      amount_cents: 9999,
      description: 'Full year access - 365 days from purchase',
      features: [
        '365 days of calendar access starting from your purchase date',
        'Example: Purchase Mar 5, 2026 → Access until Mar 5, 2027',
        'Navigate through all months of your full year',
        'Detailed aspect interpretations (as seen on your weekly calendar view)',
        'House positions for all transits (as seen on your weekly calendar view)',
        'Exact timing for all aspects (as seen on your weekly calendar view)',
        'Personalized to your natal chart',
        'Priority support',
        'Mobile and desktop access',
        'Cancel anytime'
      ],
      badgeText: 'BEST VALUE',
      subText: null,
      checkoutTotal: '$99.99/year'
    }
  },

  NTT_WEEKLY_CALENDAR: {
    // Promotional pricing (until March 31st, 2026)
    promo: {
      price: 'FREE',
      amount_cents: 0,
      description: 'Free Trial - Pricing to be announced',
      features: [
        '🎉 FREE Trial - Pricing to be announced',
        '7 days of calendar access from your purchase date',
        'Example: Purchase Jan 15 → Access until Jan 22',
        'View natal-to-current aspects for the week',
        'Detailed aspect interpretations for natal planet transits',
        'See when current planets aspect your natal chart',
        'Exact timing for all natal aspects',
        'Personalized to your birth chart',
        'Mobile and desktop access'
      ],
      badgeText: 'FREE TRIAL',
      subText: 'Free Trial - Pricing to be announced',
      checkoutTotal: 'FREE'
    },

    // Regular pricing (starting April 1st, 2026)
    regular: {
      price: '2.99',
      amount_cents: 299,
      description: '7 days of calendar access from purchase date',
      features: [
        '7 days of calendar access from your purchase date',
        'Example: Purchase Jan 15 → Access until Jan 22',
        'View natal-to-current aspects for the week',
        'Detailed aspect interpretations for natal planet transits',
        'See when current planets aspect your natal chart',
        'Exact timing for all natal aspects',
        'Personalized to your birth chart',
        'Mobile and desktop access',
        'Cancel anytime'
      ],
      badgeText: 'WEEKLY ACCESS',
      subText: null,
      checkoutTotal: '$2.99/week'
    }
  },

  NTT_MONTHLY_CALENDAR: {
    // Promotional pricing (until March 31st, 2026)
    promo: {
      price: '4.99',
      amount_cents: 499,
      description: 'Launch Special - Available until March 31st',
      features: [
        '🎉 Launch Special: $4.99 for 30 days (offer ends March 31st)',
        '🔒 Guaranteed: Lock in $4.99/month for future renewals',
        '30 days of calendar access from your purchase date',
        'Example: Purchase Jan 15 → Access until Feb 14',
        'Navigate through all weeks within your 30-day period',
        'Detailed aspect interpretations for natal planet transits',
        'See when current planets aspect your natal chart',
        'Exact timing for all natal aspects',
        'Personalized to your birth chart',
        'Mobile and desktop access'
      ],
      badgeText: 'LAUNCH SPECIAL',
      subText: 'Launch Special - Lock in this price forever!',
      checkoutTotal: '$4.99/mo'
    },

    // Regular pricing (starting April 1st, 2026)
    regular: {
      price: '7.99',
      amount_cents: 799,
      description: '30 days of calendar access from purchase date',
      features: [
        '30 days of calendar access from your purchase date',
        'Example: Purchase Jan 15 → Access until Feb 14',
        'Navigate through all weeks within your 30-day period',
        'Detailed aspect interpretations for natal planet transits',
        'See when current planets aspect your natal chart',
        'Exact timing for all natal aspects',
        'Personalized to your birth chart',
        'Mobile and desktop access',
        'Cancel anytime'
      ],
      badgeText: 'MOST POPULAR',
      subText: null,
      checkoutTotal: '$7.99/mo'
    }
  },

  NTT_ANNUAL_CALENDAR: {
    // Promotional pricing (until March 31st, 2026)
    promo: {
      price: '49.99',
      amount_cents: 4999,
      description: 'Launch Special - Available until March 31st',
      features: [
        '🎉 Launch Special: $49.99 for full year access (offer ends March 31st)',
        '🔒 Guaranteed: Lock in $49.99/year for future renewals',
        '365 days of calendar access starting from your purchase date',
        'Example: Purchase Mar 5, 2026 → Access until Mar 5, 2027',
        'Navigate through all months of your full year',
        'Detailed aspect interpretations for natal planet transits',
        'See when current planets aspect your natal chart throughout the year',
        'Exact timing for all natal aspects',
        'Personalized to your birth chart',
        'Priority support',
        'Mobile and desktop access'
      ],
      badgeText: 'LAUNCH SPECIAL',
      subText: 'Launch Special - Lock in this price forever!',
      checkoutTotal: '$49.99/year'
    },

    // Regular pricing (starting April 1st, 2026)
    regular: {
      price: '99.99',
      amount_cents: 9999,
      description: 'Full year access - 365 days from purchase',
      features: [
        '365 days of calendar access starting from your purchase date',
        'Example: Purchase Mar 5, 2026 → Access until Mar 5, 2027',
        'Navigate through all months of your full year',
        'Detailed aspect interpretations for natal planet transits',
        'See when current planets aspect your natal chart throughout the year',
        'Exact timing for all natal aspects',
        'Personalized to your birth chart',
        'Priority support',
        'Mobile and desktop access',
        'Cancel anytime'
      ],
      badgeText: 'BEST VALUE',
      subText: null,
      checkoutTotal: '$99.99/year'
    }
  },

  // PERSONAL TRANSIT CALENDAR (Natal-to-Transit) - NT
  NT_WEEKLY_CALENDAR: {
    // Promotional pricing (until March 31st, 2026)
    promo: {
      price: 'FREE',
      amount_cents: 0,
      description: 'FREE until March 31st, 2027',
      features: [
        '🎉 FREE until March 31st, 2026',
        '7 days of calendar access from your purchase date',
        'Example: Purchase Jan 15 → Access until Jan 22',
        'View when transiting planets aspect YOUR natal planets',
        'Detailed aspect interpretations for direct natal transits',
        'See your personal planetary activations',
        'Exact timing for all personal aspects',
        'Personalized to your birth chart',
        'Mobile and desktop access'
      ],
      badgeText: 'FREE TRIAL',
      subText: 'FREE until March 31st!',
      checkoutTotal: 'FREE'
    },

    // Regular pricing (starting April 1st, 2026)
    regular: {
      price: '3.99',
      amount_cents: 399,
      description: '7 days of calendar access from purchase date',
      features: [
        '7 days of calendar access from your purchase date',
        'Example: Purchase Jan 15 → Access until Jan 22',
        'View when transiting planets aspect YOUR natal planets',
        'Detailed aspect interpretations for direct natal transits',
        'See your personal planetary activations',
        'Exact timing for all personal aspects',
        'Personalized to your birth chart',
        'Mobile and desktop access',
        'Cancel anytime'
      ],
      badgeText: 'WEEKLY ACCESS',
      subText: null,
      checkoutTotal: '$3.99/week'
    }
  },

  NT_MONTHLY_CALENDAR: {
    // Promotional pricing (until March 31st, 2026)
    promo: {
      price: '4.99',
      amount_cents: 499,
      description: 'Launch Special - Available until March 31st',
      features: [
        '🎉 Launch Special: $4.99 for 30 days (offer ends March 31st)',
        '🔒 Guaranteed: Lock in $4.99/month for future renewals',
        '30 days of calendar access from your purchase date',
        'Example: Purchase Jan 15 → Access until Feb 14',
        'Navigate through all weeks within your 30-day period',
        'Detailed aspect interpretations for direct natal transits',
        'See when transiting planets aspect YOUR natal planets',
        'Exact timing for all personal aspects',
        'Personalized to your birth chart',
        'Mobile and desktop access'
      ],
      badgeText: 'LAUNCH SPECIAL',
      subText: 'Launch Special - Lock in this price forever!',
      checkoutTotal: '$4.99/mo'
    },

    // Regular pricing (starting April 1st, 2026)
    regular: {
      price: '9.99',
      amount_cents: 999,
      description: '30 days of calendar access from purchase date',
      features: [
        '30 days of calendar access from your purchase date',
        'Example: Purchase Jan 15 → Access until Feb 14',
        'Navigate through all weeks within your 30-day period',
        'Detailed aspect interpretations for direct natal transits',
        'See when transiting planets aspect YOUR natal planets',
        'Exact timing for all personal aspects',
        'Personalized to your birth chart',
        'Mobile and desktop access',
        'Cancel anytime'
      ],
      badgeText: 'MOST POPULAR',
      subText: null,
      checkoutTotal: '$9.99/mo'
    }
  },

  NT_ANNUAL_CALENDAR: {
    // Promotional pricing (until March 31st, 2026)
    promo: {
      price: '49.99',
      amount_cents: 4999,
      description: 'Launch Special - Available until March 31st',
      features: [
        '🎉 Launch Special: $49.99 for full year access (offer ends March 31st)',
        '🔒 Guaranteed: Lock in $49.99/year for future renewals',
        '365 days of calendar access starting from your purchase date',
        'Example: Purchase Mar 5, 2026 → Access until Mar 5, 2027',
        'Navigate through all months of your full year',
        'Detailed aspect interpretations for direct natal transits',
        'See when transiting planets aspect YOUR natal planets throughout the year',
        'Exact timing for all personal aspects',
        'Personalized to your birth chart',
        'Priority support',
        'Mobile and desktop access'
      ],
      badgeText: 'LAUNCH SPECIAL',
      subText: 'Launch Special - Lock in this price forever!',
      checkoutTotal: '$49.99/year'
    },

    // Regular pricing (starting April 1st, 2026)
    regular: {
      price: '99.99',
      amount_cents: 9999,
      description: 'Full year access - 365 days from purchase',
      features: [
        '365 days of calendar access starting from your purchase date',
        'Example: Purchase Mar 5, 2026 → Access until Mar 5, 2027',
        'Navigate through all months of your full year',
        'Detailed aspect interpretations for direct natal transits',
        'See when transiting planets aspect YOUR natal planets throughout the year',
        'Exact timing for all personal aspects',
        'Personalized to your birth chart',
        'Priority support',
        'Mobile and desktop access',
        'Cancel anytime'
      ],
      badgeText: 'BEST VALUE',
      subText: null,
      checkoutTotal: '$99.99/year'
    }
  }
};

/**
 * Get current monthly calendar pricing based on promo status
 * @returns {Object} Current pricing configuration
 */
export const getCurrentPricing = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.MONTHLY_CALENDAR.promo
    : PRICING_CONFIG.MONTHLY_CALENDAR.regular;
};

/**
 * Get current annual calendar pricing based on promo status
 * @returns {Object} Current pricing configuration
 */
export const getCurrentAnnualPricing = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.ANNUAL_CALENDAR.promo
    : PRICING_CONFIG.ANNUAL_CALENDAR.regular;
};

/**
 * Get amount in cents for monthly calendar payment processing
 * @returns {number} Amount in cents
 */
export const getMonthlyCalendarAmountCents = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.MONTHLY_CALENDAR.promo.amount_cents
    : PRICING_CONFIG.MONTHLY_CALENDAR.regular.amount_cents;
};

/**
 * Get amount in cents for annual calendar payment processing
 * @returns {number} Amount in cents
 */
export const getAnnualCalendarAmountCents = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.ANNUAL_CALENDAR.promo.amount_cents
    : PRICING_CONFIG.ANNUAL_CALENDAR.regular.amount_cents;
};

/**
 * Get current NTT weekly calendar pricing based on promo status
 * @returns {Object} Current pricing configuration
 */
export const getNttWeeklyPricing = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NTT_WEEKLY_CALENDAR.promo
    : PRICING_CONFIG.NTT_WEEKLY_CALENDAR.regular;
};

/**
 * Get current NTT monthly calendar pricing based on promo status
 * @returns {Object} Current pricing configuration
 */
export const getNttMonthlyPricing = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NTT_MONTHLY_CALENDAR.promo
    : PRICING_CONFIG.NTT_MONTHLY_CALENDAR.regular;
};

/**
 * Get current NTT annual calendar pricing based on promo status
 * @returns {Object} Current pricing configuration
 */
export const getNttAnnualPricing = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NTT_ANNUAL_CALENDAR.promo
    : PRICING_CONFIG.NTT_ANNUAL_CALENDAR.regular;
};

/**
 * Get amount in cents for NTT weekly calendar payment processing
 * @returns {number} Amount in cents
 */
export const getNttWeeklyAmountCents = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NTT_WEEKLY_CALENDAR.promo.amount_cents
    : PRICING_CONFIG.NTT_WEEKLY_CALENDAR.regular.amount_cents;
};

/**
 * Get amount in cents for NTT monthly calendar payment processing
 * @returns {number} Amount in cents
 */
export const getNttMonthlyAmountCents = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NTT_MONTHLY_CALENDAR.promo.amount_cents
    : PRICING_CONFIG.NTT_MONTHLY_CALENDAR.regular.amount_cents;
};

/**
 * Get amount in cents for NTT annual calendar payment processing
 * @returns {number} Amount in cents
 */
export const getNttAnnualAmountCents = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NTT_ANNUAL_CALENDAR.promo.amount_cents
    : PRICING_CONFIG.NTT_ANNUAL_CALENDAR.regular.amount_cents;
};

/**
 * Get current NT weekly calendar pricing based on promo status
 * @returns {Object} Current pricing configuration
 */
export const getNtWeeklyPricing = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NT_WEEKLY_CALENDAR.promo
    : PRICING_CONFIG.NT_WEEKLY_CALENDAR.regular;
};

/**
 * Get current NT monthly calendar pricing based on promo status
 * @returns {Object} Current pricing configuration
 */
export const getNtMonthlyPricing = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NT_MONTHLY_CALENDAR.promo
    : PRICING_CONFIG.NT_MONTHLY_CALENDAR.regular;
};

/**
 * Get current NT annual calendar pricing based on promo status
 * @returns {Object} Current pricing configuration
 */
export const getNtAnnualPricing = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NT_ANNUAL_CALENDAR.promo
    : PRICING_CONFIG.NT_ANNUAL_CALENDAR.regular;
};

/**
 * Get amount in cents for NT weekly calendar payment processing
 * @returns {number} Amount in cents
 */
export const getNtWeeklyAmountCents = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NT_WEEKLY_CALENDAR.promo.amount_cents
    : PRICING_CONFIG.NT_WEEKLY_CALENDAR.regular.amount_cents;
};

/**
 * Get amount in cents for NT monthly calendar payment processing
 * @returns {number} Amount in cents
 */
export const getNtMonthlyAmountCents = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NT_MONTHLY_CALENDAR.promo.amount_cents
    : PRICING_CONFIG.NT_MONTHLY_CALENDAR.regular.amount_cents;
};

/**
 * Get amount in cents for NT annual calendar payment processing
 * @returns {number} Amount in cents
 */
export const getNtAnnualAmountCents = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE
    ? PRICING_CONFIG.NT_ANNUAL_CALENDAR.promo.amount_cents
    : PRICING_CONFIG.NT_ANNUAL_CALENDAR.regular.amount_cents;
};

/**
 * Check if promotional pricing is active
 * @returns {boolean} True if promo is active
 */
export const isPromoActive = () => {
  return PRICING_CONFIG.IS_PROMO_ACTIVE;
};

export default PRICING_CONFIG;
